import { render, staticRenderFns } from "./TipsModal.vue?vue&type=template&id=18c18d0f&scoped=true&"
import script from "./TipsModal.vue?vue&type=script&lang=ts&"
export * from "./TipsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TipsModal.vue?vue&type=style&index=0&id=18c18d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c18d0f",
  null
  
)

export default component.exports